import React, { Component, PropTypes } from 'react';
import AddButtonView from './AddButtonView';
import TablePanel from './TablePanel';

class TablePanelView extends Component {
    render() {
        return (
            <div>
                <div>
                    <h3>{this.props.headline}</h3>
                    <TablePanel
                        id={this.props.id + '-panel'}
                        list={this.props.list}
                        isDisabled={this.props.isDisabled}
                        editConfigRow={this.props.editConfigRow}
                        deleteConfigRow={this.props.deleteConfigRow}
                        single={this.props.single}
                        firstColumn={this.props.firstColumn}
                        secondColumn={this.props.secondColumn}
                        columns={this.props.columns}
                    />
                    <AddButtonView
                        onSubmit={this.props.onSubmit}
                        isDisabled={this.props.isDisabled}
                        clearComments={this.props.clearComments}
                        moreButtons={this.props.moreButtons}
                        clearCode={this.props.clearCode}
                        id={this.props.id}
                    >
                        {this.props.children}
                    </AddButtonView>
                </div>
            </div>
        );
    }
}

TablePanelView.propTypes = {
    content: PropTypes.array,
    onSubmit: PropTypes.func,
    contentLevel: PropTypes.object,
    onDispatch: PropTypes.func,
    headline: PropTypes.string,
    buttonComment: PropTypes.string,
    id: PropTypes.string,
    children: PropTypes.element,
    onShowInfo: PropTypes.func
};

export default TablePanelView;



// WEBPACK FOOTER //
// ./src/components/pages/pages/configurationListSettings/TablePanelView.js